// src/app/services/[service]/components/api/ApiSupport.jsx
"use client";

import React from "react";
import styles from "./ApiSupport.module.css";
import { apiSupportCards as CARDS } from "../../data/api-development";

export default function ApiSupport() {
  return (
    <section className={`${styles.section} py-5`}>
      <div className="container">
        <div className={styles.wrap}>
          {/* Left intro */}
          <div>
            <div className={styles.eyebrow}>Support Services</div>
            <h2 className={styles.title}>API Development Support Services</h2>
            <p className={styles.desc}>
              Our team offers support and solutions for implementing REST, XML,
              and RPC, enhancing API performance to guarantee efficient
              operations and precise data handling for all users.
            </p>
            <div className={styles.pattern} aria-hidden></div>
          </div>

          {/* Right cards */}
          <div className={styles.grid}>
            {CARDS.map((c) => (
              <div key={c.title} className={styles.card}>
                <span className={styles.icon} aria-hidden>
                  <i className={c.icon}></i>
                </span>
                <h3 className={styles.ctitle}>{c.title}</h3>
                <p className={styles.cdesc}>{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
